import React from 'react';
import { Spring, config } from "react-spring";
import VisibilitySensor from 'react-visibility-sensor';
import CircularProgressbar from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';

class CircularBar extends React.Component{
    
    render() {
       return (
          <VisibilitySensor>
            {({ isVisible }) => {
              return (
                  <Spring
                    from={{ percentage: 0 }}
                    to={{ percentage: this.props.percentage }}
                    config={config.slow}
                  >
                    {({ percentage }) => {

                      let roundedPercentage = Math.round(percentage);
                      let text = ''  ;
                      if (this.props.extra !== '') {
                          text =  this.props.extra;
                      }
                      return (
                        <div>
                        <CircularProgressbar
                          percentage={roundedPercentage}
                          text={`+${this.props.round}`+ text}
                          className={this.props.type}
                        />
                      </div>
                      );
                    }}
                  </Spring>
              );
            }}
          </VisibilitySensor>
       );
    }
}
export default CircularBar;
